import { Link } from 'react-router-dom';

const industries = [
  { icon: 'ri-settings-5-line', label: 'Производство' },
  { icon: 'ri-ship-line', label: 'Логистика' },
  { icon: 'ri-building-4-line', label: 'Строительство' },
  { icon: 'ri-home-4-line', label: 'Недвижимость' },
  { icon: 'ri-computer-line', label: 'IT' },
  { icon: 'ri-graduation-cap-line', label: 'EdTech' },
  { icon: 'ri-heart-pulse-line', label: 'Медицина' },
  { icon: 'ri-store-2-line', label: 'Дистрибуция' },
  { icon: 'ri-briefcase-line', label: 'Услуги' },
  { icon: 'ri-building-3-line', label: 'Промышленность' },
  { icon: 'ri-bank-line', label: 'Финансовый сектор' },
  { icon: 'ri-building-2-line', label: 'B2B' },
];

export default function IndustriesSection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Где применяется корпоративное обучение продажам
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Отраслевая специфика учитывается при разработке каждой <Link to="/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya" className="text-teal-600 hover:text-teal-700 underline">программы обучения</Link> — кейсы, аргументация и практические задания адаптируются под ваш бизнес
        </p>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 max-w-4xl mx-auto">
          {industries.map((ind, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-4 flex items-center gap-3 hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group cursor-default">
              <div className="w-9 h-9 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${ind.icon} text-sm text-white`}></i>
              </div>
              <span className="text-gray-800 text-sm font-medium">{ind.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}